<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <!--工具条-->
            <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

            <!--类别看板-->
            <div class="tbl-scroll-host cat-list-host">
                <div class="cat-list" v-loading="listLoading">
                    <div v-if="!listLoading && !(categories && categories.length)" class="cat-list__empty">
                        <i class="el-icon-folder-opened"></i>
                        <span>暂无检查类别，请点击上方「新增一级」</span>
                    </div>
                    <article
                        v-for="l1 in categories"
                        :key="l1.Id"
                        class="cat-group"
                        :class="{ 'is-open': isGroupOpen(l1.Id) }"
                    >
                        <div class="cat-group__head" @click="toggleGroup(l1.Id)">
                            <button class="cat-group__fold" type="button" tabindex="-1" :title="isGroupOpen(l1.Id) ? '收起' : '展开'">
                                <i :class="isGroupOpen(l1.Id) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                            </button>
                            <div class="cat-group__main">
                                <div class="cat-group__name">{{ l1.Name }}</div>
                                <div class="cat-group__meta">
                                    <span class="cat-tag cat-tag--blue"><i class="el-icon-school"></i> {{ l1.CampusName || '全校通用' }}</span>
                                    <span class="cat-tag cat-tag--green"><i class="el-icon-medal"></i> {{ l1.InitialScore }} 分</span>
                                    <span class="cat-tag cat-tag--gray"><i class="el-icon-folder"></i> {{ (l1.Children && l1.Children.length) || 0 }} 个子类</span>
                                    <span v-if="l1.SystemOnly" class="cat-tag cat-tag--warn"><i class="el-icon-lock"></i> 仅自动</span>
                                </div>
                            </div>
                            <div class="cat-group__ops" @click.stop>
                                <el-button type="text" size="mini" icon="el-icon-plus" class="cat-btn-add" @click="handleAddSub1(l1)">添加二级</el-button>
                                <el-button type="text" size="mini" icon="el-icon-edit" class="cat-btn-edit" @click="handleEdit(l1)">编辑</el-button>
                                <el-button type="text" size="mini" icon="el-icon-delete" class="cat-btn-danger" @click="handleDel(l1)">删除</el-button>
                            </div>
                        </div>
                        <div v-show="isGroupOpen(l1.Id)" class="cat-group__body">
                            <div
                                v-for="l2 in (l1.Children || [])"
                                :key="l2.Id"
                                class="cat-child"
                            >
                                <div class="cat-child__main">
                                    <span class="cat-child__dot"></span>
                                    <span class="cat-child__name">{{ l2.Name }}</span>
                                    <span class="cat-child__count" :class="{ 'is-empty': resolveItemCount(l2) <= 0 }">
                                        <i class="el-icon-document-checked"></i>
                                        检查项 {{ resolveItemCount(l2) }}
                                    </span>
                                </div>
                                <div class="cat-child__ops">
                                    <el-button type="text" size="mini" icon="el-icon-document" class="cat-btn-subitem" @click="handleItems(l2)">检查项</el-button>
                                    <el-button type="text" size="mini" icon="el-icon-edit" class="cat-btn-edit" @click="handleEdit(l2)">编辑</el-button>
                                    <el-button type="text" size="mini" icon="el-icon-delete" class="cat-btn-danger" @click="handleDel(l2)">删除</el-button>
                                </div>
                            </div>
                            <div v-if="!(l1.Children && l1.Children.length)" class="cat-child--empty">
                                <span>当前分类下暂无二级类型，</span>
                                <span class="empty-add-btn" @click="handleAddSub1(l1)"><i class="el-icon-plus"></i>立即添加二级</span>
                            </div>
                        </div>
                    </article>
                </div>
            </div>

            <!--分页-->
            <div class="pagination-container">
                <el-pagination layout="total,prev, pager, next" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="page" :page-size="PageSize" :total="total"
                    style="float: right"></el-pagination>
            </div>

            <!--编辑界面-->
            <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="30%" :close-on-click-modal="false">
                <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
                    <!-- 去除所属部门选择，直接关联页面统一选中的学校 ID -->


                    <!-- 新增二级：先选校区，再选父级类别 -->
                    <el-form-item label="校区" v-if="editForm.Level === 2 && !editForm.Id && !level2FromParentRow" prop="CampusId">
                        <el-select v-model.number="editForm.CampusId" placeholder="请先选择校区" style="width: 100%"
                            @change="handleLevel2CampusChange">
                            <el-option :value="0" label="学校通用模板" />
                            <el-option v-for="c in campusOptions" :key="c.Id" :label="c.Name"
                                :value="normalizeCampusId(c.Id)" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="校区" v-if="editForm.Level === 2 && !editForm.Id && level2FromParentRow">
                        <el-input :value="resolveCampusLabel(editForm)" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="父级类别"
                        v-if="editForm.Level === 2 && editForm.DepartmentId && level2CampusSelected && !level2FromParentRow"
                        prop="ParentId">
                        <el-select v-model="editForm.ParentId" placeholder="请选择父级类别" style="width: 100%">
                            <el-option v-for="item in parentCategories" :key="item.Id" :label="item.Name"
                                :value="item.Id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="父级类别" v-if="editForm.Level === 2 && !editForm.Id && level2FromParentRow">
                        <el-input :value="level2ParentName" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="校区" v-if="editForm.Level === 1" prop="CampusId">
                        <el-select v-model.number="editForm.CampusId" placeholder="请选择校区" style="width: 100%">
                            <el-option :value="0" label="学校通用模板" />
                            <el-option v-for="c in campusOptions" :key="c.Id" :label="c.Name"
                                :value="normalizeCampusId(c.Id)" />
                        </el-select>
                        <div v-if="editForm.Id" class="form-tip">修改校区将同步更新其下所有二级类别</div>
                    </el-form-item>

                    <el-form-item label="类别名称" prop="Name">
                        <el-input v-model="editForm.Name" maxlength="50"></el-input>
                    </el-form-item>

                    <el-form-item label="初始分" v-if="editForm.Level === 1" prop="InitialScore">
                        <el-input-number v-model="editForm.InitialScore" :precision="2" :step="0.1" :min="0" :max="1000"
                            style="width: 100%">
                        </el-input-number>
                    </el-form-item>

                    <el-form-item label="系统专用" v-if="editForm.Level === 1">
                        <el-switch v-model="editForm.SystemOnly" active-text="仅自动记账" inactive-text="可手选" />
                        <div class="form-tip">开启后该一级下全部检查项：值周/手机端不可手选。</div>
                    </el-form-item>

                    <el-form-item label="排序号" prop="SortOrder">
                        <el-input-number v-model="editForm.SortOrder" :min="0" style="width: 100%">
                        </el-input-number>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="editSubmit" :loading="editLoading">确 定</el-button>
                </div>
            </el-dialog>

            <!--检查项目列表对话框-->
            <el-dialog :title="(currentCategory && currentCategory.Name) ? (currentCategory.Name + ' - 检查项目') : '检查项目'"
                :visible.sync="itemsDialogVisible" width="900px" top="8vh" :close-on-click-modal="false"
                custom-class="duty-items-dialog">
                <!-- 直接创建按钮 -->
                <div class="item-toolbar">
                    <el-button type="primary" icon="el-icon-plus" @click="handleAddItem">新增</el-button>
                </div>

                <!--项目列表-->
                <el-table :data="items" v-loading="itemsLoading" class="duty-items-table"
                    :height="itemsTableHeight" style="width: 100%; margin-top: 12px;">
                    <el-table-column prop="Name" label="检查项" min-width="240" align="left">
                        <template slot-scope="scope">
                            <span class="item-name-link" @click="handleEditItem(scope.row)">{{ scope.row.Name }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="ChangeType" label="类型" width="72" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.ChangeType === 'Addition' ? 'success' : 'danger'" size="small">
                                {{ scope.row.ChangeType === 'Addition' ? '加分' : '扣分' }}
                            </el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="ScoreValue" label="分值" width="80" align="center">
                        <template slot-scope="scope">
                            <span
                                :class="['score-value', scope.row.ChangeType === 'Addition' ? 'score-add' : 'score-deduct']">
                                {{ scope.row.ChangeType === 'Addition' ? '+' : '-' }}{{ scope.row.ScoreValue }}分
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="CreateTime" label="创建时间" width="156" align="center" />

                    <el-table-column label="操作" width="156" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" type="warning" icon="el-icon-edit"
                                @click="handleEditItem(scope.row)">
                                编辑
                            </el-button>
                            <el-button size="mini" type="danger" icon="el-icon-delete"
                                @click="handleDelItem(scope.row)">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--项目分页-->
                <div style="margin-top: 12px; display: flex; justify-content: flex-end;">
                    <el-pagination layout="total, prev, pager, next" :total="itemsTotal" :page-size="itemsPageSize"
                        :current-page="itemsPage" @current-change="handleItemsCurrentChange"
                        @size-change="handleItemsSizeChange">
                    </el-pagination>
                </div>

                <!--项目编辑界面-->
                <el-dialog title="编辑检查项" :visible.sync="editItemFormVisible" width="620px" append-to-body
                    :close-on-click-modal="false">
                    <el-form :model="editItemForm" label-width="100px" :rules="editItemFormRules" ref="editItemForm">
                        <el-form-item label="检查项" prop="Name">
                            <el-input type="textarea" v-model="editItemForm.Name" :rows="8" maxlength="500"
                                show-word-limit placeholder="请输入检查项内容"></el-input>
                        </el-form-item>

                        <el-form-item label="类型" prop="ChangeType">
                            <el-radio-group v-model="editItemForm.ChangeType" @change="handleTypeChange('edit')">
                                <el-radio label="Deduction">扣分</el-radio>
                                <el-radio label="Addition">加分</el-radio>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item label="分值" prop="ScoreValue">
                            <div class="score-input-wrapper">
                                <span class="score-prefix">{{ editItemForm.ChangeType === 'Addition' ? '+' : '-'
                                    }}</span>
                                <el-input-number v-model="editItemForm.ScoreValue" :precision="2" :step="0.1" :min="0"
                                    :max="1000" controls-position="right" style="width: calc(100% - 20px)">
                                </el-input-number>
                            </div>
                        </el-form-item>

                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="editItemFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="editItemSubmit" :loading="editItemLoading">确 定</el-button>
                    </div>
                </el-dialog>

                <!--项目新增界面-->
                <el-dialog title="新增检查项" :visible.sync="addItemFormVisible" width="620px" append-to-body
                    :close-on-click-modal="false">
                    <el-form :model="addItemForm" label-width="100px" :rules="addItemFormRules" ref="addItemForm">
                        <el-form-item label="检查项" prop="Name">
                            <el-input type="textarea" v-model="addItemForm.Name" :rows="8" maxlength="500"
                                show-word-limit placeholder="请输入检查项内容"></el-input>
                        </el-form-item>

                        <el-form-item label="类型" prop="ChangeType" @change="handleTypeChange('add')">
                            <el-radio-group v-model="addItemForm.ChangeType">
                                <el-radio label="Deduction">扣分</el-radio>
                                <el-radio label="Addition">加分</el-radio>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item label="分值" prop="ScoreValue">
                            <div class="score-input-wrapper">
                                <span class="score-prefix">{{ addItemForm.ChangeType === 'Addition' ? '+' : '-'
                                }}</span>
                                <el-input-number v-model="addItemForm.ScoreValue" :precision="2" :step="0.1" :min="0"
                                    :max="1000" controls-position="right" style="width: calc(100% - 20px)">
                                </el-input-number>
                            </div>
                        </el-form-item>

                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="addItemFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="addItemSubmit" :loading="addItemLoading">确 定</el-button>
                    </div>
                </el-dialog>
            </el-dialog>

        </section>

        <!-- 导入 -->
        <import-result-dialog
            :visible.sync="importResultVisible"
            :result="importResult"
        />

        <el-dialog :visible.sync="dutyImportDialogVisible" width="860px" custom-class="person-import-dialog"
            :close-on-click-modal="false" append-to-body @closed="onDutyImportDialogClosed">
            <div slot="title" class="pi-dialog-title">
                <span class="pi-dialog-title__icon"><i class="el-icon-s-check"></i></span>
                <div>
                    <strong>批量导入值日检查项</strong>
                    <p>下载模板填写后上传，学校以顶部所选为准</p>
                </div>
            </div>
            <div class="pi-body">
                <div class="pi-steps">
                    <div class="pi-step"><span class="pi-step__no">1</span><div><strong>下载模板</strong><em>按列填写检查分类与项目</em></div></div>
                    <i class="el-icon-arrow-right pi-step__arrow"></i>
                    <div class="pi-step"><span class="pi-step__no">2</span><div><strong>上传 Excel</strong><em>支持 .xlsx / .xls</em></div></div>
                    <i class="el-icon-arrow-right pi-step__arrow"></i>
                    <div class="pi-step"><span class="pi-step__no">3</span><div><strong>核对导入</strong><em>预览后再确认写入</em></div></div>
                </div>
                <button type="button" class="pi-template-card" @click="downloadDutyImportTemplate">
                    <span class="pi-template-card__icon"><i class="el-icon-document"></i></span>
                    <span class="pi-template-card__meta">
                        <strong>值日检查批量导入模板.xlsx</strong>
                        <em>含一级/二级类型、检查项目等；无需填写学校</em>
                    </span>
                    <span class="pi-template-card__action"><i class="el-icon-download"></i>下载模板</span>
                </button>
                <el-upload :key="'duty-upload-' + dutyImportUploadKey" class="pi-upload" drag action="#"
                    :auto-upload="false" :limit="1" :show-file-list="false" accept=".xlsx,.xls"
                    :on-change="onDutyImportFileChange" :on-remove="onDutyImportFileRemove" :on-exceed="onDutyImportExceed">
                    <div v-if="dutyImportFileRaw" class="pi-upload__file">
                        <i class="el-icon-success pi-upload__ok"></i>
                        <div><strong>{{ dutyImportFileRaw.name }}</strong><em>已选择，点击「解析并预览」</em></div>
                    </div>
                    <div v-else class="pi-upload__empty">
                        <i class="el-icon-upload2"></i><strong>点击选择或拖拽 Excel 到此处</strong><em>仅支持 .xlsx / .xls</em>
                    </div>
                </el-upload>
            </div>
            <div slot="footer" class="pi-footer">
                <el-button @click="dutyImportDialogVisible = false">关闭</el-button>
                <el-button type="primary" icon="el-icon-view" :disabled="!dutyImportFileRaw"
                    :loading="dutyImportParsing" @click="parseDutyImportFile">解析并预览</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="excelShow" :close-on-click-modal="false" width="78%"
            custom-class="person-import-dialog" append-to-body
            :before-close="(done) => { this.backToDutyImportSelect(); done(); }">
            <div slot="title" class="pi-dialog-title">
                <span class="pi-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
                <div><strong>值日检查导入核对</strong><p>共 {{ outputs.length }} 条，确认无误后写入系统</p></div>
            </div>
            <el-table :data="pagedOutputs" class="pi-preview-table" border stripe style="width: 100%" max-height="520">
                <el-table-column prop="CategoryLevel1" label="检查类型（一级）" min-width="120" show-overflow-tooltip />
                <el-table-column prop="InitScore" label="初始分" width="80" show-overflow-tooltip />
                <el-table-column prop="CategoryLevel2" label="检查类型（二级）" min-width="120" show-overflow-tooltip />
                <el-table-column prop="ItemName" label="检查项目" min-width="120" show-overflow-tooltip />
                <el-table-column prop="ItemType" label="项目类型" width="100" show-overflow-tooltip />
                <el-table-column prop="ItemScore" label="项目分值" width="90" show-overflow-tooltip />
                <el-table-column fixed="right" label="操作" align="center" width="90">
                    <template slot-scope="scope">
                        <el-button type="text" class="pi-row-del" @click="removeImport(scope)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pi-preview-pager">
                <el-pagination local-paging layout="total, prev, pager, next, jumper" :total="outputs.length"
                    :page-size="importPageSize" :current-page.sync="importPage"
                    @current-change="handleImportCurrentChange" @size-change="handleImportSizeChange" />
            </div>
            <div slot="footer" class="pi-footer">
                <el-button @click="backToDutyImportSelect">返回上一步</el-button>
                <el-button type="primary" icon="el-icon-upload2" :disabled="!outputs.length" @click="SavaImport">确认导入</el-button>
            </div>
        </el-dialog>

    </section>
</template>

<script>
import util from "../../../util/date";
import { getDutyInspectCategoryListPage, editDutyInspectCategory, addDutyInspectCategory, deleteDutyInspectCategory, getDutyInspectItemListPage, editDutyInspectItem, addDutyInspectItem, deleteDutyInspectItem, getParentsByDepartment, importDutyInspectItems } from '../../api/modules/moral-education';
import { getCampusList } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import ImportResultDialog from '../../components/ImportResultDialog'
import { normalizeImportBatchResponse } from '../../utils/importResultParser'
import { read, utils, writeFile } from 'xlsx'
import '../../style/person-import-dialog.css'
import { deptIdsEqual, normalizeDeptId } from '../../utils/deptCascaderProps'

export default {
    components: { Toolbar, DepartmentPane, ImportResultDialog },
    data() {
        return {
            filters: {
                campusId: null,
            },
            searchList: [
                {
                    label: '名称',
                    key: 'name',
                },
                {
                    label: '校区',
                    key: 'campusId',
                    type: 'select',
                    clearable: true,
                    init: false,
                    initValue: null,
                    options: [
                        { label: '全部校区', value: -1 },
                        { label: '学校通用模板', value: 0 },
                    ],
                },
            ],
            campusOptions: [],
            treeSelectNode: null,
            schoolDepartmentId: 0,
            categories: [],
            expandedGroups: {},
            items: [],
            parentCategories: [],
            total: 0,
            buttonList: [],
            itemButtonList: [],
            currentRow: null,
            currentCategory: null,
            page: 1,
            PageSize: 10,
            listLoading: false,
            itemsLoading: false,
            sels: [],
            DepartmentId: 0,
            itemsDialogVisible: false,
            itemsPage: 1,
            itemsPageSize: 8,
            itemsTotal: 0,
            // 类别编辑相关
            editFormVisible: false,
            editLoading: false,
            dialogTitle: '',
            level2FromParentRow: false,
            level2ParentName: '',
            editFormRules: {
                Name: [{ required: true, message: "请输入类别名称", trigger: "blur" }],
                InitialScore: [
                    { required: true, message: "请输入初始分", trigger: "blur" },
                    { type: 'number', message: "请输入有效的数字", trigger: "blur" }
                ],
                CampusId: [{
                    validator: (rule, value, callback) => {
                        if (this.editForm.Level !== 2 || this.editForm.Id || this.level2FromParentRow) {
                            return callback()
                        }
                        if (value === null || value === undefined || value === '') {
                            callback(new Error('请选择校区'))
                        } else {
                            callback()
                        }
                    },
                    trigger: 'change'
                }],
                ParentId: [
                    { required: true, message: '请选择父级类别', trigger: 'change' }
                ],
            },
            editForm: {
                Id: 0,
                Name: '',
                InitialScore: 100,
                DepartmentId: 0,
                CampusId: 0,
                ParentId: null,
                Level: 1,
                SortOrder: 0,
                SystemOnly: false,
            },

            // 项目编辑相关
            editItemFormVisible: false,
            editItemLoading: false,
            editItemFormRules: {
                Name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
                ChangeType: [{ required: true, message: "请选择类型", trigger: "change" }],
                ScoreValue: [
                    { required: true, message: "请输入分值", trigger: "blur" },
                    { type: 'number', message: "请输入有效的数字", trigger: "blur" }
                ],
            },
            editItemForm: {
                Id: 0,
                Name: '',
                CategoryId: 0,
                ChangeType: 'Deduction',
                ScoreValue: 0,
            },

            // 项目新增相关
            addItemFormVisible: false,
            addItemLoading: false,
            addItemFormRules: {
                Name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
                ChangeType: [{ required: true, message: "请选择类型", trigger: "change" }],
                ScoreValue: [
                    { required: true, message: "请输入分值", trigger: "blur" },
                    { type: 'number', message: "请输入有效的数字", trigger: "blur" }
                ],
            },
            addItemForm: {
                Name: '',
                CategoryId: 0,
                ChangeType: 'Deduction',
                ScoreValue: 0,
            },

            //excel
            outputs: [],
            excelShow: false,
            dutyImportDialogVisible: false,
            dutyImportFileRaw: null,
            dutyImportParsing: false,
            dutyImportUploadKey: 0,
            dutyImportKeepFileOnClose: false,
            importResultVisible: false,
            importResult: null,
            // 导入分页
            importPage: 1,
            importPageSize: 10,
        };
    },
    computed: {
        pagedOutputs() {
            const start = (this.importPage - 1) * this.importPageSize;
            return (this.outputs || []).slice(start, start + this.importPageSize);
        },
        /** 新增二级时已选定校区（含学校通用模板 0） */
        level2CampusSelected() {
            if (this.editForm.Level !== 2) return false
            const campusId = this.editForm.CampusId
            return campusId !== null && campusId !== undefined && campusId !== ''
        },
        /** 检查项表格固定高度：表头 + 每页行数 * 行高，数据少时也占满 */
        itemsTableHeight() {
            const pageSize = this.itemsPageSize || 8;
            return 40 + pageSize * 56;
        },
    },
    methods: {
        isGroupOpen(id) {
            return !!(this.expandedGroups && this.expandedGroups[id]);
        },
        toggleGroup(id) {
            if (!this.expandedGroups) this.$set(this, 'expandedGroups', {});
            this.$set(this.expandedGroups, id, !this.expandedGroups[id]);
        },
        /** 树深度：优先 ParentId，其次 Level */
        resolveTreeDepth(row) {
            if (!row) return 0;
            if (row.ParentId != null && Number(row.ParentId) > 0) return 1;
            const level = Number(row.Level);
            return level >= 2 ? level - 1 : 0;
        },
        /** 二级检查项数量：优先接口 ItemCount */
        resolveItemCount(row) {
            if (!row) return 0;
            if (row.ItemCount != null && row.ItemCount !== '') return Number(row.ItemCount) || 0;
            return (row.Items && row.Items.length) || 0;
        },
        treeNodeClick(data, node, component) {
            this.DepartmentId = data.value
            this.treeSelectNode = data
            this.filters.campusId = null
            const orgType = String(data.DeptOrgType || data.deptOrgType || '').toLowerCase()
            if (orgType === 'school') {
                this.schoolDepartmentId = data.value
                this.loadCampusOptions()
            } else {
                const schoolId = data.schoolId || data.SchoolId
                if (schoolId) {
                    this.schoolDepartmentId = schoolId
                    this.loadCampusOptions()
                }
            }
            this.$nextTick(() => {
                if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
                    this.$refs.toolbar.searchObj.campusId = null
                }
                this.handleQuery()
            })
        },

        getCurrentSchoolId() {
            const schoolId = this.schoolDepartmentId || this.DepartmentId
            if (!schoolId || schoolId === '0' || schoolId === 0) return 0
            return schoolId
        },

        async loadCampusOptions() {
            if (!this.schoolDepartmentId) {
                this.campusOptions = []
                this.syncCampusSearchOptions()
                return
            }
            try {
                const res = await getCampusList({
                    departmentId: this.schoolDepartmentId,
                    page: 1,
                    intPageSize: 999,
                })
                let list = (res && res.data && res.data.response && res.data.response.data) || []
                if (!list.length && this.treeSelectNode) {
                    const orgType = String(this.treeSelectNode.DeptOrgType || this.treeSelectNode.deptOrgType || '').toLowerCase()
                    if (orgType === 'campus') {
                        list = [{
                            Id: this.schoolDepartmentId,
                            Name: this.treeSelectNode.label || this.treeSelectNode.Name || '当前校区',
                        }]
                    }
                }
                this.campusOptions = list
                this.syncCampusSearchOptions()
            } catch {
                this.campusOptions = []
                this.syncCampusSearchOptions()
            }
        },

        /** 同步 Toolbar 校区下拉（选项 value 统一为数字，避免与 searchObj 类型不一致无法回显） */
        syncCampusSearchOptions() {
            const opts = [
                { label: '全部校区', value: -1 },
                { label: '学校通用模板', value: 0 },
            ].concat((this.campusOptions || []).map((c) => ({
                label: c.Name,
                value: normalizeDeptId(c.Id) || c.Id,
            })))
            const idx = this.searchList.findIndex((s) => s.key === 'campusId')
            if (idx >= 0) {
                this.$set(this.searchList, idx, {
                    ...this.searchList[idx],
                    init: false,
                    initValue: null,
                    options: opts,
                })
            }
            this.$nextTick(() => {
                const tb = this.$refs.toolbar
                if (!tb || !tb.searchObj) return
                const current = tb.searchObj.campusId
                if (current === null || current === undefined || current === '') return
                const normalized = this.normalizeCampusId(current)
                if (!opts.some((o) => this.normalizeCampusId(o.value) === normalized || deptIdsEqual(o.value, normalized))) return
                this.$set(tb.searchObj, 'campusId', normalized)
            })
        },

        handleQuery(keepExpanded = true) {
            let para = {
                departmentId: this.DepartmentId,
                page: this.page,
                intPageSize: this.PageSize,
            }
            if (this.filters.name) {
                para.name = this.filters.name
            }
            // 未选或「全部校区」时不传 campusId，后端返回该校全部模板
            const cid = this.filters.campusId
            if (cid != null && cid !== '' && Number(cid) >= 0) {
                para.campusId = cid
            }
            this.listLoading = true;
            getDutyInspectCategoryListPage(para).then((res) => {
                this.total = res.data.response.dataCount
                this.PageSize = res.data.response.PageSize
                this.categories = res.data.response.data || []
                this.listLoading = false
                const hasKeyword = !!(this.filters.name && String(this.filters.name).trim());
                if (hasKeyword) {
                    const expanded = { ...(this.expandedGroups || {}) };
                    (this.categories || []).forEach((item) => {
                        if (item && item.Id) expanded[item.Id] = true;
                    });
                    this.expandedGroups = expanded;
                } else if (keepExpanded) {
                    // 保留已展开状态
                    const nextExpanded = { ...(this.expandedGroups || {}) };
                    this.expandedGroups = nextExpanded;
                } else {
                    this.expandedGroups = {};
                }
            });
        },

        handleCurrentChange(val) {
            this.page = val;
            this.handleQuery(true);
        },

        handleSizeChange(val) {
            this.PageSize = val;
            this.handleQuery(true);
        },

        handleAdd() {
            const schoolId = this.getCurrentSchoolId()
            if (!schoolId) {
                this.$message.warning('请先在左侧选择具体的学校机构！')
                return
            }
            this.level2FromParentRow = false
            this.dialogTitle = '新增一级类别';
            this.editFormVisible = true;
            this.editForm = {
                Id: 0,
                Name: '',
                InitialScore: 100,
                DepartmentId: schoolId,
                CampusId: this.normalizeCampusId(
                    this.filters.campusId != null ? this.filters.campusId : 0,
                ),
                ParentId: null,
                Level: 1,
                SortOrder: 0,
                SystemOnly: false,
            };
            if (this.schoolDepartmentId) this.loadCampusOptions()
        },

        // 头部添加二级类别
        handleAddSub() {
            const schoolId = this.getCurrentSchoolId()
            if (!schoolId) {
                this.$message.warning('请先在左侧选择具体的学校机构！')
                return
            }
            this.level2FromParentRow = false
            this.level2ParentName = ''
            this.dialogTitle = '新增二级类别';
            this.editFormVisible = true;
            this.parentCategories = []
            let initialCampusId = null
            const filterCampus = this.filters.campusId
            if (filterCampus != null && filterCampus !== '' && (filterCampus === -1 || filterCampus === 0 || filterCampus === '-1' || filterCampus === '0' || normalizeDeptId(filterCampus))) {
                initialCampusId = this.normalizeCampusId(filterCampus)
            }
            this.editForm = {
                Id: 0,
                Name: '',
                InitialScore: 0,
                DepartmentId: schoolId,
                CampusId: initialCampusId,
                ParentId: null,
                Level: 2,
                SortOrder: 0,
            };
            if (this.schoolDepartmentId) this.loadCampusOptions()
            if (initialCampusId !== null) {
                this.loadParentCategories(schoolId)
            }
        },

        // 从行添加子类别
        handleAddSub1(row) {
            this.level2FromParentRow = true
            this.level2ParentName = row.Name || ''
            this.dialogTitle = '新增二级类别';
            this.editFormVisible = true;
            this.editForm = {
                Id: 0,
                Name: '',
                InitialScore: 0,
                DepartmentId: row.DepartmentId,
                CampusId: this.normalizeCampusId(row.CampusId),
                ParentId: row.Id,
                Level: 2,
                SortOrder: 0,
            };

            if (this.schoolDepartmentId) this.loadCampusOptions()
            this.loadParentCategories(row.DepartmentId);
        },

        handleLevel2CampusChange() {
            this.editForm.ParentId = null
            this.parentCategories = []
            if (this.editForm.DepartmentId && this.level2CampusSelected) {
                this.loadParentCategories(this.editForm.DepartmentId)
            }
        },

        // 根据部门ID加载父级类别（二级新增须先选校区）
        resolveParentCategoryCampusId() {
            if (this.editForm.Level === 2) {
                if (!this.level2CampusSelected) return -1
                return this.normalizeCampusId(this.editForm.CampusId)
            }
            if (this.editForm.CampusId != null && this.editForm.CampusId !== '') {
                return this.normalizeCampusId(this.editForm.CampusId)
            }
            const filterCampusId = this.filters.campusId
            if (filterCampusId != null && filterCampusId !== '' && (filterCampusId === -1 || filterCampusId === '-1' || filterCampusId === 0 || filterCampusId === '0' || normalizeDeptId(filterCampusId))) {
                return this.normalizeCampusId(filterCampusId)
            }
            return -1
        },

        loadParentCategories(departmentId) {
            const campusId = this.resolveParentCategoryCampusId()
            if (campusId < 0) {
                this.parentCategories = []
                return
            }
            getParentsByDepartment({ departmentId, campusId }).then((res) => {
                if (res.data.success) {
                    this.parentCategories = res.data.response || []
                }
            })
        },

        /** 统一校区 Id：0/-1 为模板占位，真实校区为字符串 Id。最后修改：2026-10-18 */
        normalizeCampusId(campusId) {
            if (campusId === null || campusId === undefined || campusId === '') return 0;
            if (campusId === -1 || campusId === '-1') return -1;
            if (campusId === 0 || campusId === '0') return 0;
            return normalizeDeptId(campusId) || 0;
        },

        resolveCampusLabel(row) {
            if (!row) return '';
            if (row.CampusName) return row.CampusName;
            const campusId = this.normalizeCampusId(row.CampusId);
            if (!campusId) return '学校通用模板';
            const c = (this.campusOptions || []).find((x) => deptIdsEqual(this.normalizeCampusId(x.Id), campusId) || this.normalizeCampusId(x.Id) === campusId);
            return c ? c.Name : ('校区' + campusId);
        },

        // 编辑
        handleEdit(row) {
            this.level2FromParentRow = false
            this.dialogTitle = row.Level === 1 ? '编辑一级类别' : '编辑二级类别';
            this.editFormVisible = true;
            this.editForm = Object.assign({}, row, {
                DepartmentName: row.DepartmentName,
                CampusId: this.normalizeCampusId(row.CampusId),
                SystemOnly: !!(row && row.SystemOnly),
            });

            if (row.Level === 1) {
                this.schoolDepartmentId = row.DepartmentId || this.schoolDepartmentId;
                this.loadCampusOptions();
            }

            // 加载父级类别（仅用于二级类别）
            if (row.Level === 2) {
                this.loadParentCategories(row.DepartmentId);
            }
        },

        // 提交表单
        editSubmit() {
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    this.$confirm("确认提交吗？", "提示", {}).then(() => {
                        this.editLoading = true;
                        let para = Object.assign({}, this.editForm);

                        if (!para.Id && !para.DepartmentId) {
                            para.DepartmentId = this.getCurrentSchoolId();
                        }
                        delete para.Dids;
                        if (para.Level === 1) {
                            para.CampusId = this.normalizeCampusId(para.CampusId);
                        }

                        // 根据是否有ID来判断是新增还是编辑
                        const apiCall = para.Id ? editDutyInspectCategory : addDutyInspectCategory;

                        apiCall(para).then((res) => {
                            if (util.isEmt.format(res)) {
                                this.editLoading = false;
                                return;
                            }
                            if (res.data.success) {
                                this.editLoading = false;
                                this.$message({
                                    message: res.data.msg,
                                    type: "success",
                                });
                                this.editFormVisible = false;

                                // 确保刚刚操作的父级一级或新建的一级处于展开状态
                                const targetParentId = para.Level === 2 ? para.ParentId : null;
                                const newId = para.Id || (res.data.response && (res.data.response.Id || res.data.response));
                                if (targetParentId) {
                                    this.$set(this.expandedGroups, targetParentId, true);
                                } else if (newId) {
                                    this.$set(this.expandedGroups, newId, true);
                                }

                                this.handleQuery(true);
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error",
                                });
                                this.editLoading = false;
                            }
                        });
                    });
                }
            });
        },

        handleDel(row) {
            this.$confirm("确认删除该记录吗?", "提示", {
                type: "warning",
            })
                .then(() => {
                    this.listLoading = true;
                    let para = { id: row.Id };
                    deleteDutyInspectCategory(para).then((res) => {
                        if (util.isEmt.format(res)) {
                            this.listLoading = false;
                            return;
                        }
                        this.listLoading = false;
                        if (res.data.success) {
                            this.$message({
                                message: "删除成功",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: "error",
                            });
                        }
                        this.handleQuery();
                    });
                })
                .catch(() => { });
        },

        handleItems(row) {
            this.currentCategory = row;
            this.itemsPage = 1;
            this.itemsDialogVisible = true;
            this.getItems();
        },

        getItems() {
            let para = {
                categoryId: this.currentCategory.Id,
                page: this.itemsPage,
                intPageSize: this.itemsPageSize,
            }
            this.itemsLoading = true;
            getDutyInspectItemListPage(para).then((res) => {
                this.items = res.data.response.data;
                this.itemsTotal = res.data.response.dataCount;
                this.itemsPageSize = res.data.response.PageSize;
                this.itemsLoading = false;
            });
        },

        handleItemsCurrentChange(val) {
            this.itemsPage = val;
            this.getItems();
        },

        handleItemsSizeChange(val) {
            this.itemsPageSize = val;
            this.itemsPage = 1;
            this.getItems();
        },

        callFunction(item) {
            if (typeof item.search == 'object') {
                this.filters = Object.assign({}, this.filters, item.search)
                const campusId = item.search.campusId
                if (campusId !== null && campusId !== undefined && campusId !== '') {
                    this.$nextTick(() => {
                        if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
                            this.$set(this.$refs.toolbar.searchObj, 'campusId', this.normalizeCampusId(campusId))
                        }
                    })
                }
            } else {
                this.filters = Object.assign({}, this.filters, { name: item.search })
            }
            this[item.Func].apply(this, item)
        },

        callItemFunction(item) {
            this[item.Func].apply(this, item)
        },

        handleEditItem(row) {
            console.log(row);
            if (!row) {
                this.$message({
                    message: "请选择要编辑的一行数据！",
                    type: "error",
                });
                return;
            }
            this.editItemForm = Object.assign({}, row);
            this.editItemFormVisible = true;
        },

        // 处理类型变化
        handleTypeChange(type) {
            this.$nextTick(() => {
                if (type === 'edit') {
                    this.$refs.editItemForm && this.$refs.editItemForm.validateField('ScoreValue');
                } else {
                    this.$refs.addItemForm && this.$refs.addItemForm.validateField('ScoreValue');
                }
            });
        },

        editItemSubmit() {
            this.$refs.editItemForm.validate((valid) => {
                if (valid) {
                    this.$confirm("确认提交吗？", "提示", {}).then(() => {
                        this.editItemLoading = true;
                        let para = Object.assign({}, this.editItemForm);

                        // 根据是否有ID来判断是新增还是编辑
                        const apiCall = para.Id ? editDutyInspectItem : addDutyInspectItem;

                        apiCall(para).then((res) => {
                            if (util.isEmt.format(res)) {
                                this.editItemLoading = false;
                                return;
                            }
                            if (res.data.success) {
                                this.editItemLoading = false;
                                this.$message({
                                    message: res.data.msg,
                                    type: "success",
                                });
                                this.$refs["editItemForm"].resetFields();
                                this.editItemFormVisible = false;
                                this.getItems();
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error",
                                });
                                this.editItemLoading = false;
                            }
                        });
                    });
                }
            });
        },

        handleDelItem(row) {
            if (!row) {
                this.$message({
                    message: "请选择要删除的一行数据！",
                    type: "error",
                });
                return;
            }
            this.$confirm("确认删除该记录吗?", "提示", {
                type: "warning",
            })
                .then(() => {
                    this.itemsLoading = true;
                    let para = { id: row.Id };
                    deleteDutyInspectItem(para).then((res) => {
                        if (util.isEmt.format(res)) {
                            this.itemsLoading = false;
                            return;
                        }
                        this.itemsLoading = false;
                        if (res.data.success) {
                            this.$message({
                                message: "删除成功",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: "error",
                            });
                        }
                        this.getItems();
                    });
                })
                .catch(() => { });
        },

        handleAddItem() {
            this.addItemFormVisible = true;
            this.addItemForm = {
                Name: '',
                CategoryId: this.currentCategory.Id,
                ChangeType: 'Deduction',
                ScoreValue: 0,
            };
        },

        addItemSubmit() {
            this.$refs.addItemForm.validate((valid) => {
                if (valid) {
                    this.$confirm("确认提交吗？", "提示", {}).then(() => {
                        this.addItemLoading = true;
                        let para = Object.assign({}, this.addItemForm);
                        addDutyInspectItem(para).then((res) => {
                            if (util.isEmt.format(res)) {
                                this.addItemLoading = false;
                                return;
                            }
                            if (res.data.success) {
                                this.addItemLoading = false;
                                this.$message({
                                    message: res.data.msg,
                                    type: "success",
                                });
                                this.$refs["addItemForm"].resetFields();
                                this.addItemFormVisible = false;
                                this.getItems();
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error",
                                });
                                this.addItemLoading = false;
                            }
                        });
                    });
                }
            });
        },

        // 导入
        ImportCensus() {
            this.resetDutyImportDialog();
            this.dutyImportDialogVisible = true;
        },
        resetDutyImportDialog() {
            this.dutyImportFileRaw = null;
            this.dutyImportParsing = false;
            this.dutyImportUploadKey += 1;
        },
        onDutyImportDialogClosed() {
            if (this.dutyImportKeepFileOnClose) {
                this.dutyImportKeepFileOnClose = false;
                return;
            }
            this.resetDutyImportDialog();
        },
        backToDutyImportSelect() {
            this.excelShow = false;
            this.dutyImportDialogVisible = true;
        },
        onDutyImportFileChange(file) {
            this.dutyImportFileRaw = file && file.raw ? file.raw : null;
        },
        onDutyImportFileRemove() {
            this.dutyImportFileRaw = null;
        },
        onDutyImportExceed(files) {
            const nextFile = files && files[0];
            if (!nextFile) return;
            this.dutyImportUploadKey += 1;
            this.$nextTick(() => { this.dutyImportFileRaw = nextFile; });
        },
        downloadDutyImportTemplate() {
            const headers = ['检查类型（一级）', '检查类型初始分', '检查类型（二级）', '检查项目（三级）', '项目类型', '项目分值'];
            const sample = ['卫生检查', '100', '教室卫生', '地面整洁', '扣分', '2'];
            const sheet = utils.aoa_to_sheet([headers, sample]);
            const book = utils.book_new();
            utils.book_append_sheet(book, sheet, '值日检查导入');
            writeFile(book, '值日检查批量导入模板.xlsx');
        },
        parseDutyImportFile() {
            if (!this.dutyImportFileRaw) {
                this.$message.warning('请先选择 Excel 文件');
                return;
            }
            const file = this.dutyImportFileRaw;
            if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
                this.$message.error('上传格式不正确，请上传 xls 或 xlsx 格式');
                return;
            }
            this.dutyImportParsing = true;
            const fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    const workbook = read(ev.target.result, { type: 'binary' });
                    const ws = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
                    this.outputs = this.reSetKey(ws);
                    this.importPage = 1;
                    this.dutyImportParsing = false;
                    this.dutyImportKeepFileOnClose = true;
                    this.dutyImportDialogVisible = false;
                    this.excelShow = true;
                } catch (e) {
                    this.dutyImportParsing = false;
                    this.$message.error('文件读取失败');
                }
            };
            fileReader.onerror = () => {
                this.dutyImportParsing = false;
                this.$message.error('文件读取失败');
            };
            fileReader.readAsBinaryString(file);
        },
        resolveActiveSchoolId() {
            const raw = this.$store.state.activeSchoolId || window.localStorage.getItem('activeSchoolId');
            if (raw === null || raw === undefined || raw === '' || raw === '0') return null;
            return raw;
        },
        showImportResult(resData) {
            this.importResult = (resData && resData.response) || null;
            this.importResultVisible = true;
            const normalized = normalizeImportBatchResponse(resData || {});
            if (!normalized.items.length) {
                const text = normalized.summary || (resData && resData.msg) || '';
                if (text) this.$message.success(text);
            }
        },

        removeImport(e) {
            const name = e.row.ItemName || e.row.CategoryLevel1 || '该行';
            this.$confirm('确定要删除 ' + name + ' 的信息?').then(() => {
                const realIndex = (this.importPage - 1) * this.importPageSize + e['$index'];
                this.outputs.splice(realIndex, 1);
                if (this.importPage > 1 && this.pagedOutputs.length === 0) {
                    this.importPage = this.importPage - 1;
                }
            });
        },
        SavaImport() {
            const schoolDepartmentId = this.resolveActiveSchoolId();
            if (!schoolDepartmentId) {
                this.$message.warning('请先在顶部选择学校');
                return;
            }
            if (!this.outputs.length) {
                this.$message.warning('没有可导入的数据，请检查导入内容');
                return;
            }
            const loading = this.$loading({ lock: true, text: '导入中', background: 'rgba(0, 0, 0, 0.7)' });
            importDutyInspectItems({ schoolDepartmentId: schoolDepartmentId, items: this.outputs })
                .then((res) => {
                    loading.close();
                    if (res.data && res.data.success) {
                        this.excelShow = false;
                        this.showImportResult(res.data);
                        this.handleQuery();
                    } else {
                        this.showImportResult(res.data || {});
                        if (!this.importResult) {
                            this.$message.error((res.data && res.data.msg) || '导入失败');
                        }
                    }
                })
                .catch(() => {
                    loading.close();
                    this.$message.error('导入失败');
                });
        },
        reSetKey(ws) {
            const temp = [];
            ws.forEach((item) => {
                temp.push({
                    CategoryLevel1: item['检查类型（一级）'] || item['CategoryLevel1'] || '',
                    InitScore: item['检查类型初始分'] || item['InitScore'] || '',
                    CategoryLevel2: item['检查类型（二级）'] || item['CategoryLevel2'] || '',
                    ItemName: item['检查项目（三级）'] || item['ItemName'] || '',
                    ItemType: item['项目类型'] || item['ItemType'] || '',
                    ItemScore: item['项目分值'] || item['ItemScore'] || '',
                });
            });
            return temp;
        },
        // 导入分页处理
        handleImportCurrentChange(page) {
            this.importPage = page;
        },
        handleImportSizeChange(size) {
            this.importPageSize = size;
            this.importPage = 1;
        },
    },
    mounted() {
        let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    },
};
</script>

<style scoped>
.muted-dash {
    color: #c0c4cc;
}

.form-tip {
    margin-top: 4px;
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
}

.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

.score-value {
    font-weight: 500;
    font-size: 14px;
}

.score-add {
    color: #67c23a;
}

.score-deduct {
    color: #f56c6c;
}

.dialog-footer {
    text-align: right;
    padding-top: 20px;
}

.score-input-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
}

.score-prefix {
    margin-right: 8px;
    font-size: 16px;
    font-weight: 500;
    color: #606266;
}

.score-input-wrapper .el-input-number {
    flex: 1;
}

.item-name-link {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    white-space: normal;
    color: #409eff;
    cursor: pointer;
    line-height: 20px;
    max-height: 40px;
}

.item-name-link:hover {
    text-decoration: underline;
}

.duty-items-table >>> .el-table__body td {
    height: 56px;
    padding-top: 0;
    padding-bottom: 0;
    vertical-align: middle;
}

.duty-items-table >>> .el-table__body .cell {
    line-height: 20px;
}

.duty-items-table >>> .el-table__body-wrapper {
    overflow-x: hidden;
}
</style>

<style>
/* el-dialog custom-class 挂在外层，需非 scoped */
.duty-items-dialog {
    width: 900px !important;
    max-width: calc(100vw - 48px);
}

.duty-items-dialog .el-dialog__body {
    max-height: calc(84vh - 120px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 12px;
}

.duty-items-dialog .duty-items-table {
    width: 100% !important;
}

.duty-items-dialog .el-table__body-wrapper.is-scrolling-none,
.duty-items-dialog .el-table__body-wrapper.is-scrolling-left,
.duty-items-dialog .el-table__body-wrapper.is-scrolling-right,
.duty-items-dialog .el-table__body-wrapper.is-scrolling-middle {
    overflow-x: hidden !important;
}

</style>
